import { StoreCore, createStore } from "@priolo/jon"
import farmSo from "stores/farm"
import { LastDateRange } from "stores/planner/utils/fetch"

import { Consumption, ConsumptionByCrop } from "types/Consumption"
import { haveValueDateRange, includeDateRange } from "utils"
import { BucketMode, YIELD_TYPE } from "./types"
import consumptionApi from "api/consumption"
import { FetchPayload } from "stores/cycle/types"
import { DateRange } from "types/global"




const setup = {

	state: {
		drawerOpen: false,
		bucketMode: <BucketMode>'week',
		yieldType: <YIELD_TYPE>YIELD_TYPE.ACTUAL,
		consumptions: <ConsumptionByCrop>null,

		lastRange: <DateRange>null,
		lastFarmId: <number>null,
	},

	getters: {

	},

	actions: {
		fetchConsumptionsByCropLot: async (_: void, store?: StatsStore) => {
			const farmId = farmSo.state.select?.id
			if ( farmId == store.state.lastFarmId && includeDateRange(store.state.lastRange, LastDateRange ) ) return

			store.setConsumptions(null)
			const items = (await consumptionApi.byCrop(farmId, LastDateRange))?.data
			store.setConsumptions(items)
			
			store.state.lastFarmId = farmId
			store.state.lastRange = LastDateRange
		},
		/** permette di aggiornare il drawer STATISTICS */
		update: (_: void, store?: StatsStore) => {
			if (!store.state.drawerOpen) return
			store.fetchConsumptionsByCropLot()
		},
	},

	mutators: {
		setDrawerOpen: (drawerOpen: boolean) => ({ drawerOpen }),
		setBucketMode: (bucketMode: BucketMode) => ({ bucketMode }),
		setYieldType: (yieldType: YIELD_TYPE) => ({ yieldType }),
		setConsumptions: (consumptions: ConsumptionByCrop) => ({ consumptions }),
	},
}

export type StatsState = typeof setup.state
export type StatsGetters = typeof setup.getters
export type StatsActions = typeof setup.actions
export type StatsMutators = typeof setup.mutators
export interface StatsStore extends StoreCore<StatsState>, StatsGetters, StatsActions, StatsMutators {
	state: StatsState
}
const statsSo = createStore(setup) as StatsStore
export default statsSo


